export default "__VITE_ASSET__CjUr$pf5__";